import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Package, Tag, MessageSquare, Building2, Users, UtensilsCrossed, Percent, BarChart3, FileText, Settings, ShoppingCart, ClipboardList, UserCircle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
interface NavItem {
  path: string;
  label: string;
  icon: React.ElementType;
  adminOnly?: boolean;
}
export function TopNav() {
  const {
    user
  } = useAuth();
  // Admin navigation items
  const adminNavItems: NavItem[] = [{
    path: '/admin/orders',
    label: 'Órdenes',
    icon: LayoutDashboard
  }, {
    path: '/admin/production',
    label: 'Producción',
    icon: Package,
    adminOnly: true
  }, {
    path: '/admin/labels',
    label: 'Etiquetas',
    icon: Tag,
    adminOnly: true
  }, {
    path: '/admin/claims',
    label: 'Reclamaciones',
    icon: MessageSquare,
    adminOnly: true
  }, {
    path: '/admin/companies',
    label: 'Empresas',
    icon: Building2,
    adminOnly: true
  }, {
    path: '/admin/employees',
    label: 'Empleados',
    icon: Users,
    adminOnly: true
  }, {
    path: '/admin/menu',
    label: 'Menú',
    icon: UtensilsCrossed,
    adminOnly: true
  }, {
    path: '/admin/promotions',
    label: 'Promociones',
    icon: Percent,
    adminOnly: true
  }, {
    path: '/admin/reports',
    label: 'Reportes',
    icon: BarChart3,
    adminOnly: true
  }, {
    path: '/admin/activity-log',
    label: 'Registro',
    icon: FileText,
    adminOnly: true
  }, {
    path: '/admin/settings',
    label: 'Configuración',
    icon: Settings,
    adminOnly: true
  }];
  // Employee navigation items
  const employeeNavItems: NavItem[] = [{
    path: '/employee/order',
    label: 'Hacer Pedido',
    icon: ShoppingCart
  }, {
    path: '/employee/my-orders',
    label: 'Mis Pedidos',
    icon: ClipboardList
  }, {
    path: '/employee/profile',
    label: 'Mi Perfil',
    icon: UserCircle
  }];
  // Select navigation based on user role
  const navItems = user?.role === 'admin' ? adminNavItems : employeeNavItems;
  const filteredNavItems = navItems.filter(item => !item.adminOnly || user?.role === 'admin');
  return <nav className="bg-white border-b border-gray-200 sticky top-16 z-30" data-id="element-627">
      <div className="px-4 lg:px-8" data-id="element-628">
        <div className="flex items-center justify-center gap-1 overflow-x-auto scrollbar-hide py-2" data-id="element-629">
          {filteredNavItems.map(item => {
          const Icon = item.icon;
          return <NavLink key={item.path} to={item.path} className={({
            isActive
          }) => `group flex items-center gap-2 px-4 py-2.5 rounded-lg transition-all duration-150 whitespace-nowrap ${isActive ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'}`} data-id="element-630">
                {({
              isActive
            }) => <>
                    <Icon size={18} strokeWidth={isActive ? 2.5 : 2} className="shrink-0" data-id="element-631" />
                    <span className={`text-sm ${isActive ? 'font-semibold' : 'font-medium'}`} data-id="element-632">
                      {item.label}
                    </span>
                  </>}
              </NavLink>;
        })}
        </div>
      </div>
    </nav>;
}